export type FormatLocaleCurrencyInput = number;

/**
 * Display options for Money formatting
 *
 * BACKWARDS COMPATIBLE: Keeps existing 'rounded' option
 * NEW: Adds optional 'precision' parameter for explicit control
 */
export type FormatLocaleCurrencyOptions = {
  locale?: string;
  currency?: string;
  rounded?: boolean;
  precision?: number; // NEW: Explicit precision (0-5), overrides 'rounded'
};

export type FormatLocaleCurrencyOutput = string;

export const formatLocaleCurrency = (
  input: FormatLocaleCurrencyInput,
  options?: FormatLocaleCurrencyOptions
): FormatLocaleCurrencyOutput => {
  // Determine fraction digits with priority: precision > rounded > default
  let fractionDigits: number;

  if (options?.precision !== undefined) {
    // Explicit precision takes highest priority
    fractionDigits = options.precision;

    // Validate precision range
    if (fractionDigits < 0 || fractionDigits > 5) {
      fractionDigits = 5;
    }
  } else if (options?.rounded) {
    fractionDigits = 0;
  } else {
    fractionDigits = 5; // Default: 5 decimal places
  }

  return new Intl.NumberFormat(options?.locale ?? "id-ID", {
    style: "currency",
    currency: options?.currency ?? "IDR",
    currencyDisplay: "symbol",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(input);
};

export default formatLocaleCurrency;
